<template>
  <el-container>
    <el-main>
      <h3 class="heading">Edit feed</h3>
      <el-card>
        <FeedForm
          v-if="feed"
          v-model="feed"
          :loading="loading"
          action-text="Update"
          @submit="onSubmit"
        />
      </el-card>
      <LoadingBlock :loading="fetchingFeed" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, provide, reactive, ref, watch } from 'vue'
import { useFeedsStore } from '@/store/modules/feeds'
import { FeedValidationErrorsKey } from '@/api/types'
import { IFeedAttributes } from '@/interfaces/feeds'
import useRouter from '@/hooks/useRouter'
import { ElMessage } from 'element-plus'
import FeedForm from '../components/FeedForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import useValidation from '@/hooks/useValidation'
import useFetchFeed from '@/hooks/useFetchFeed'
import { safeSubmitProcessing } from '@/utils/helpers'
import { useSpotsListsStore } from '@/apps/traforama/store/spotsLists'
export default defineComponent({
  name: 'EditFeed',
  components: {
    FeedForm,
    LoadingBlock
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const feedsStore = useFeedsStore()
    const spotsListsStore = useSpotsListsStore()
    const { provideValidation, setValidationErrors } = useValidation(
      FeedValidationErrorsKey
    )
    const errors = provideValidation()

    const loading = ref(false)
    const { router } = useRouter()

    const { feed, fetchingFeed, FetchItem } = useFetchFeed()

    FetchItem(props.id)

    const onSuccess = async () => {
      await router.push('/feeds')
      ElMessage.success({ message: 'Feed has been updated' })
    }

    const onSubmit = async ({ feed }: { feed: IFeedAttributes }) => {
      await safeSubmitProcessing(
        loading,
        () => feedsStore.SaveItem(feed),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    watch(
      feed,
      (newValue, oldValue) => {
        if (
          newValue &&
          (!oldValue ||
            oldValue.type_ids !== newValue.type_ids ||
            oldValue.ron_type !== newValue.ron_type)
        ) {
          spotsListsStore.FetchItems({
            filter: {
              type_id: newValue.type_ids,
              ron_type: newValue.ron_type
            }
          })
        }
      },
      { deep: true }
    )

    return { feed, loading, onSubmit, fetchingFeed }
  }
})
</script>
